import routerOptions0 from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@22.15.19_@vue+compiler-sfc@3.5.17_better-_edf76cc00fb4590ec5dec46b5c1c309b/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "smooth"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}